<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    <h2>{{'BATCH-PROCESS.TITLE' | translate}}</h2>

    <ntr-datatable [data]="data" [metaInfo]="metaInfo" [modelView]="'batch-process'" [entityTitle]="'batch process'" [disableHeader]="false" (onQuery)="onGridQuery($event)" [columns]="columns" (onDeleteQuery)="deleteBatchProcess($event)" [headers]="[]"></ntr-datatable>
</div>